import React, { StrictMode } from 'react'
import styled, { ThemeProvider } from 'styled-components'
import Helmet from 'react-helmet'
import { AnimatePresence } from 'framer-motion'
import Navigation from '@safetywing-tech/global-navbar'
import favicon from 'images/favicon.ico'
import { GlobalStyle, theme, sizes } from 'styles'
import 'fonts/font.css'

const Container = styled.div`
  position: relative;
  width: 100%;
  max-width: 1600px;
  height: 100%;
  max-width: 1600px;
  min-height: 100vh;
  padding: 40px 20px;
  padding-top: ${({ paddingTop }) => paddingTop || '90px'};
  margin: 0 auto;

  @media ${sizes.tabletPortrait} {
    padding: 40px;
    padding-top: ${({ paddingTop }) => paddingTop || '90px'};
  }

  @media ${sizes.desktop} {
    padding-top: 110px;
  }
`

const PageWrapper = ({ children }) => {
  return (
    <>
      <Helmet>
        <link rel="icon" href={favicon} />
      </Helmet>
      <ThemeProvider theme={theme}>
        <StrictMode>
          <GlobalStyle />
          <Navigation
            pageType={{
              isGlobal: true,
            }}
            mainSiteUrl="https://safetywing.com"
          />
          <Container>
            <AnimatePresence exitBeforeEnter>{children}</AnimatePresence>
          </Container>
          <div id="modal-portal" />
        </StrictMode>
      </ThemeProvider>
    </>
  )
}

export default PageWrapper
